export default __webpack_public_path__ + "static/media/plan_function_002.42320afc.jpg";